import axios from "axios";
import { ENV } from "../config/env";
import tokenService from "../services/tokenService";
import { authService } from "../services/authService";

const apiClient = axios.create({
  baseURL: ENV.API_URL,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (token) => {
  failedQueue.forEach((callback) => callback(token));
  failedQueue = [];
};

// Request
apiClient.interceptors.request.use(
  (config) => {
    const token = tokenService.getAccessToken();
    if (token) {
      // Your backend accepts the raw token
      config.headers.Authorization = "Bearer " + token;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// Response
apiClient.interceptors.response.use(
  (response) => response,

  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve) => {
          failedQueue.push((token) => {
            originalRequest.headers.Authorization = "Bearer " + token;
            resolve(apiClient(originalRequest));
          });
        });
      }

      isRefreshing = true;

      try {
        const result = await authService.refreshToken();
        
        if (!result.isSuccess) {
          throw new Error("Refresh token failed");
        }

        tokenService.setTokens(result.value);

        processQueue(result.value.accessToken);

        originalRequest.headers.Authorization =
          "Bearer " + result.value.accessToken;

        return apiClient(originalRequest);
      } catch (err) {
        tokenService.clearTokens();

        window.location.href = "/";

        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  },
);

export default apiClient;
